module.exports = __webpack_public_path__ + "static/img/cloud_xpress_connect_img_2.c8ece00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_xpress_connect_img_2.jpg
// module id = RQUP
// module chunks = 0